"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AirplaneLargeSVG_1 = __importDefault(require("../SVG/AirplaneLargeSVG"));
const styles_1 = __importDefault(require("./styles"));
const AnimatedAirplaneAngle = ({ className, fill, style, }) => {
    const classes = styles_1.default();
    return (react_1.default.createElement("div", { className: classes.airplaneContainer },
        react_1.default.createElement(AirplaneLargeSVG_1.default, { className: className || classes.airplane, fill: fill, style: style })));
};
exports.default = AnimatedAirplaneAngle;
